<template>
  <div class="tal logCon">
    <h4 class="f20 fw">
      当前网吧：<b>{{ this.$route.query.barID }}</b>
    </h4>
    <ButtonGroup class="btnCon" size="small">
      <Button
        :type="curIp == item ? 'primary' : 'default'"
        v-for="(item, index) in ip"
        :key="index"
        >{{ item }}</Button
      >
    </ButtonGroup>
    <div class="dataCon clearfix">
      <div class="fl navCon">
        <ul class="tac">
          <li :class="{ cur: val == 1 }" @click="selectFn(1)">进程树</li>
          <li :class="{ cur: val == 2 }" @click="selectFn(2)">DNS请求记录</li>
          <li :class="{ cur: val == 3 }" @click="selectFn(3)">文件操作记录</li>
          <li :class="{ cur: val == 4 }" @click="selectFn(4)">拦截通知</li>
        </ul>
      </div>
      <div class="fr contentCon">
        <ProcessCom
          v-if="val == 1"
          :processLog="processLog"
          :modalLog="modalLog"
          :tcpLog="tcpLog"
        ></ProcessCom>
        <VirtualList
          :size="30"
          :remain="6"
          style="height: 100%; overflow-y: auto;width:100%;"
          v-else-if="val == 2"
        >
          <DnsCom :data="dnsLog" />
        </VirtualList>
        <VirtualList
          :size="30"
          :remain="6"
          style="height: 100%; overflow-y: auto;width:100%;"
          v-else-if="val == 3"
        >
          <FileCom :fileLog="fileLog" />
        </VirtualList>
        <VirtualList
          :size="30"
          :remain="6"
          style="height: 100%; overflow-y: auto;width:100%;"
          v-else-if="val == 4"
        >
          <InterceptCom :data="interceptLog" />
        </VirtualList>
      </div>
    </div>
  </div>
</template>
<script>
import VirtualList from 'vue-virtual-scroll-list'
import ProcessCom from '_c/record/process'
import DnsCom from '_c/record/dns'
import FileCom from '_c/record/file'
import InterceptCom from '_c/record/intercept'
export default {
  components: { ProcessCom, DnsCom, FileCom, InterceptCom },
  data() {
    return {
      barId: '',
      curIp: '',
      cfg: '',
      ip: [],
      processLog: [],
      fileLog: [],
      interceptLog: [],
      dnsLog: [],
      modalLog: [],
      tcpLog: [],
      val: 1,
    }
  },

  mounted() {
    this.cfg = this.$route.query.id
    this.barId = this.$route.query.barID
    this.ip = JSON.parse(this.cfg).ip
    this.curIp = this.ip[0]
    this.initWebSocket()
  },
  methods: {
    selectFn(val) {
      this.val = val
    },
    initWebSocket() {
      if (typeof WebSocket === 'undefined') {
        console.log('你的浏览器不支持WebSocket')
        return false
      }
      let wsUrl = 'ws://120.26.63.112:8898/log'
      //let wsUrl = 'ws://act201.weihudashi.com/log'
      this.websock = new WebSocket(wsUrl)
      this.websock.onopen = this.websocketonopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketSend(val) {},
    // 连接成功
    websocketonopen() {
      console.log('WebSocket连接成功')
      this.$store.dispatch('log/actionResetLog')
      console.log(this.barId)
      console.log(this.curIp)
      this.websock.send(`target=${this.barId}_${this.curIp}`)
    },
    // 接收后端返回的数据
    websocketonmessage(e) {
      let dataJson = JSON.parse(e.data)
      if (dataJson.error_code == 1 && this.curIp == dataJson.ip) {
        if (
          dataJson.logdata != '' &&
          dataJson.logdata.loginfo != undefined &&
          dataJson.logdata.loginfo != ''
        ) {
          this.setData(dataJson.logdata.loginfo)
        }
      }
      // if (
      //   dataJson.logdata.loginfo != '' &&
      //   dataJson.logdata.loginfo != undefined
      // ) {
      //   this.$store.dispatch(
      //     'log/actionSetRule',
      //     this.$MethodFn.Base64ToString(dataJson.logdata.loginfo)
      //   )
      // }
      // console.log(dataJson)
      // 在这里使用后端返回的数据，对数据进行处理渲染
    },
    arrayToJson(treeArray, id, parentId, children) {
      var r = []
      var tmpMap = {}

      for (var i = 0, l = treeArray.length; i < l; i++) {
        // 以每条数据的id作为obj的key值，数据作为value值存入到一个临时对象里面
        tmpMap[treeArray[i][id]] = treeArray[i]
      }

      for (i = 0, l = treeArray.length; i < l; i++) {
        var key = tmpMap[treeArray[i][parentId]]

        //循环每一条数据的pid，假如这个临时对象有这个key值，就代表这个key对应的数据有children，需要Push进去
        if (key) {
          if (!key[children]) {
            key[children] = []
            key[children].push(treeArray[i])
          } else {
            key[children].push(treeArray[i])
          }
        } else {
          //如果没有这个Key值，那就代表没有父级,直接放在最外层
          r.push(treeArray[i])
        }
      }
      console.log(r)
      console.log(222)
      return r
    },
    treeData(source, id, parentId, children) {
      let cloneData = JSON.parse(JSON.stringify(source))
      return cloneData.filter((father) => {
        let branchArr = cloneData.filter(
          (child) => father[id] == child[parentId]
        )
        console.log(branchArr)
        branchArr.length > 0 ? (father[children] = branchArr) : ''
        return father[parentId] == 0 // 如果第一层不是parentId=0，请自行修改
      })
    },
    setData(data) {
      let newData = this.$MethodFn.Base64ToString(data)
      if (newData[0].iid == 1) {
        let index = this.processLog.findIndex(
          (val) =>
            val.pid == newData[0].pid &&
            val.ppid == newData[0].ppid &&
            val.cmd == newData[0].cmd
        )
        if (index == -1) {
          this.processLog.push(newData[0])
        }
        if (newData[0].subid == 2) {
          let index = this.processLog.findIndex(
            (val) =>
              val.pid == newData[0].pid &&
              val.ppid == newData[0].ppid &&
              val.cmd == newData[0].cmd
          )
          if (index != -1) {
            this.processLog[index].destoryTime = newData[0].time
          } else {
            newData[0].destoryTime = newData[0].time
            newData[0].time = ''
            this.processLog.push(newData[0])
          }
        }
        let newJson = [...this.processLog]
        this.processLog = this.arrayToJson(newJson, 'pid', 'ppid', 'children')
      } else if (newData[0].iid == 2) {
        console.log(newData[0])
        this.modalLog.push(newData[0])
      } else if (newData[0].iid == 3) {
        if (newData[0].subid == 6) {
          this.dnsLog.push(newData[0])
        } else {
          this.tcpLog.push(newData[0])
        }
      } else if (newData[0].iid == 5) {
        this.interceptLog.push(newData[0])
      } else if (newData[0].iid == 6) {
        this.interceptLog.push(newData[0])
      } else if (newData[0].iid == 7) {
        this.fileLog.push(newData[0])
      }
    },
    // 连接建立失败重连
    websocketonerror(e) {
      console.log('连接失败的信息：', e)
      if (this.time < 3) {
        this.time++
        this.initWebSocket() // 连接失败后尝试重新连接
      }
    },
    websocketclose(e) {
      console.log('关闭链接', e)
    },
  },
}
</script>
<style lang="scss">
#app {
  height: 100%;
  width: 100%;
}
</style>
<style lang="scss" scoped>
.logCon {
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .dataCon {
    margin-top: 10px;
    width: 100%;
    height: calc(100% - 60px);
    ul {
      border: 1px solid #eee;
      li {
        line-height: 30px;
        width: 120px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
        &.cur {
          background: #00cafb;
          color: #fff;
        }
      }
    }
    .contentCon {
      width: calc(100% - 130px);
      border: 1px solid #eee;
      padding: 0 10px 20px;
      overflow: auto;
      box-sizing: border-box;
    }
  }
}
</style>
